import script from "./ShopProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopProduct.vue?vue&type=script&setup=true&lang=js"

import "./ShopProduct.vue?vue&type=style&index=0&id=71f37df6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f37df6"]])

export default __exports__